export default class Config {
    public static readonly STORAGE_TOKEN: string = "token";
}


// WEBPACK FOOTER //
// ./src/Config/Config.ts